import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectAppId } from 'core-components/sitebuilder/store/selectors/selectAppId'
import { Crud } from 'core/types/Crud'
import { TDropdownsCruds } from 'onboarding/components/widgets/public/forms/contract/models'
import { dropdownsService } from 'onboarding/services/dropdownsService'

export const useContractData = (
  setItem: (value: IObjectAny) => void,
  rid: string,
  source: Crud
) => {
  const appId = useSelector(selectAppId)

  useEffect(() => {
    rid &&
      source.getById({ id: rid, keyField: 'RequestId' }).then((el) => {
        if (el) {
          if (!el.Agreement) {
            el.Agreement = 'No'
          }
          setItem(el)
        } else {
          setItem({ Agreement: 'No' })
        }
      })
  }, [rid])

  const cruds: TDropdownsCruds = useMemo(() => {
    return {
      contractStatuses: dropdownsService.getCrud({
        appId,
        dropdown: 'contractFollowUpContractStatuses',
        cacheKey: 'contractFollowUpContractStatuses',
      }),
      agreementStatuses: dropdownsService.getCrud({
        appId,
        dropdown: 'contractFollowUpAgreementStatuses',
        cacheKey: 'contractFollowUpAgreementStatuses',
      }),
      businessStatuses: dropdownsService.getCrud({
        appId,
        dropdown: 'contractFollowUpBusinessStatuses',
        cacheKey: 'contractFollowUpBusinessStatuses',
      }),
    }
  }, [appId])

  return { cruds }
}
